/* Portfolio content lives in content.yaml (project root).
Edit that file to change what appears on the site — this file only wires
the generated data up to image assets and the shape each component expects.
Colors are controlled separately in src/_globalColor.scss. */

import emoji from "react-easy-emoji";
import content from "./content.generated";

// Auto-discovers every image under src/assets/images (recursively) at build
// time via webpack's require.context, so a path typed in content.yaml —
// e.g. "awards/spotaward.jpeg" — resolves without ever touching this file.
// Just drop the file in src/assets/images/ and reference its relative path.
const imageContext = require.context(
  "./assets/images",
  true,
  /\.(png|jpe?g|svg|webp)$/
);

function resolveImage(relPath) {
  if (!relPath) return undefined;
  const key = `./${relPath.replace(/^\.?\//, "")}`;
  try {
    return imageContext(key);
  } catch (e) {
    console.error(
      `Image not found: "${relPath}" — expected a file at src/assets/images/${relPath}`
    );
    return undefined;
  }
}

// Summary And Greeting Section

const illustration = {
  animated: true, // Set to false to use static SVG
};

const greeting = {
  username: content.greeting.username,
  title: content.greeting.title,
  subTitle: emoji(content.greeting.subTitle),
  resumeLink: content.greeting.resumeLink,
  displayGreeting: content.greeting.displayGreeting,
};

// Social Media Links

const socialMediaLinks = {
  github: content.socialMedia.github,
  linkedin: content.socialMedia.linkedin,
  display: content.socialMedia.display,
};

// Skills Section

const skillsSection = {
  title: content.skills.title,
  subTitle: content.skills.subTitle,
  skills: content.skills.bullets,
  softwareSkills: content.skills.softwareSkills,
  display: content.skills.display,
};

// Education Section

const educationInfo = {
  display: content.education.display,
  schools: content.education.schools.map(school => ({
    ...school,
    logo: resolveImage(school.logo),
  })),
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: false,
  experience: [
    {Stack: "Network Security & Protocol Research", progressPercentage: "90%"},
    {Stack: "Applied AI & AI Security", progressPercentage: "80%"},
    {Stack: "Software Engineering & Automation", progressPercentage: "85%"},
  ],
  displayCodersrank: false,
};

// Work experience section

const workExperiences = {
  display: content.workExperiences.display,
  experience: content.workExperiences.experience.map(exp => ({
    role: exp.role,
    company: exp.company,
    companylogo: resolveImage(exp.logo),
    date: exp.date,
    desc: exp.desc,
    descBullets: exp.descBullets,
  })),
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  display: false, // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  display: false, // Set false to hide this section, defaults to true
};

// Achievement Section

const achievementSection = {
  title: emoji(content.achievements.title),
  subtitle: content.achievements.subtitle,
  achievementsCards: content.achievements.items.map(item => ({
    title: item.title,
    subtitle: item.subtitle,
    image: resolveImage(item.image),
    footerLink: item.links.map(l => ({name: l.name, link: l.url})),
  })),
  display: content.achievements.display,
};

// Talks Sections

const talkSection = {
  title: content.talks.title,
  subtitle: content.talks.subtitle,
  display: content.talks.display,
  talks: content.talks.items.map(item => ({
    title: item.title,
    subtitle: item.subtitle,
    image: resolveImage(item.image),
    footerLink: item.links.map(l => ({name: l.name, url: l.url})),
  })),
};

// Blogs Section

const blogSection = {
  title: content.blogs.title,
  subtitle: content.blogs.subtitle,
  displayMediumBlogs: content.blogs.displayMediumBlogs ? "true" : "false",
  blogs: content.blogs.items,
  display: content.blogs.display,
};

// Podcast Section

const podcastSection = {
  display: false, // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji(content.contact.title),
  subtitle: content.contact.subtitle,
  number: content.contact.number,
  email_address: content.contact.email,
};

// Twitter Section

const twitterDetails = {
  display: false, // Set true to display this section, defaults to false
};

export {
  illustration,
  greeting,
  socialMediaLinks,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  talkSection,
  achievementSection,
  bigProjects,
  blogSection,
  podcastSection,
  contactInfo,
  twitterDetails,
};
